class RichRelevancePurchasedInstrumentationController {
    constructor($window, richRelevanceService) {
        this.$window = $window;
        richRelevanceService.getInformation()
            .then(() => {

                $window.R3_PURCHASED = new $window.r3_purchased(); // eslint-disable-line new-cap

                $window.R3_PURCHASED.setOrderNumber(this.order.OrderId);
                this.order.Products.forEach((product) => {
                    this.addProduct(product);
                });

                $window.rr_flush_onload();
                $window.r3();
            });
    }

    addProduct(product) {
        // WOS-5077 RichRelevance cannot accept decimal quantity and doesn't want to boost product by loose items and B2B customers quantity.
        // Therefore, we always send the qunatity as 1 and price should be line total.
        this.$window.R3_PURCHASED.addItemIdPriceQuantity(product.Stockcode, product.Subtotal, 1);
    }

}

const richRelevancePurchasedInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevancePurchasedInstrumentationController],
    bindings: {
        order: '<',
    },
};

module.exports = {
    RichRelevancePurchasedInstrumentationController,
    richRelevancePurchasedInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-purchased-instrumentation.component.js